export { default } from './PointHotspot';
export * from './PointHotspot.types';
